var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4425 1.06729L5.44254 11.0673C5.38449 11.1254 5.31556 11.1715 5.23969 11.203C5.16381 11.2344 5.08248 11.2506 5.00035 11.2506C4.91821 11.2506 4.83688 11.2344 4.76101 11.203C4.68514 11.1715 4.61621 11.1254 4.55816 11.0673L0.18316 6.69229C0.0658846 6.57502 0 6.41596 0 6.2501C0 6.08425 0.0658846 5.92519 0.18316 5.80792C0.300435 5.69064 0.459495 5.62476 0.625347 5.62476C0.7912 5.62476 0.95026 5.69064 1.06753 5.80792L5.00035 9.74151L14.5582 0.182916C14.6754 0.0656402 14.8345 -0.000244142 15.0003 -0.000244141C15.1662 -0.000244139 15.3253 0.0656402 15.4425 0.182916C15.5598 0.300191 15.6257 0.459251 15.6257 0.625103C15.6257 0.790956 15.5598 0.950016 15.4425 1.06729Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkWhite);
export default __webpack_public_path__ + "static/media/check-mark-white.d158160ee4161b970b8bfff1be7d8a6e.svg";
export { ForwardRef as ReactComponent };